import { CustomActionResultHandler } from "./Results/CustomActionResultHandler";
import { CustomContentResultHandler } from "./Results/CustomContentResultHandler";
import { EmptyResultHandler } from "./Results/EmptyResultHandler";
import { HtmlResultHandler } from "./Results/HtmlResultHandler";
import { JsonResultHandler } from "./Results/JsonResultHandler";
import { PlainTextResultHandler } from "./Results/PlainTextResultHandler";
import { StreamResultHandler } from "./Results/StreamResultHandler";

export const httpReturn = {
    Void: new EmptyResultHandler(),
    Json: new JsonResultHandler(),
    Html: new HtmlResultHandler(),
    PlainText: new PlainTextResultHandler(),
    CustomAction: new CustomActionResultHandler(),
    Stream: new StreamResultHandler(),
    StreamWithMime: (mimeType: string) => new StreamResultHandler(mimeType),
    Content: (mimeType: string) => new CustomContentResultHandler(mimeType),
};
